import { InferType, mixed, object, string } from "yup";
import { models } from "types/api/viewModels";
import { DesignerIsNotHereText } from "components/NewOrders/constants";
import {
	CharacterLimitExceeded,
	DesignerNumberMustBeSixCharactersText,
	MustStartWithOneAndContainOnlyDigitsText,
	PleaseDescribeCustomizationText,
	PleaseEnterDesignerNumberText,
	PleaseProvideItemNameText,
	PleaseSelectBillToNumberText,
	SelectAccountNumberText
} from "constants/text";

export const schema = object({
	accountNumber: mixed<models["CustomerAccountViewModel"]>().nullable().required(SelectAccountNumberText),
	billToNumber: mixed<models["BillToViewModel"]>().nullable().required(PleaseSelectBillToNumberText),
	designer: mixed<models["DesignerViewModel"] | string>().nullable(),
	customDesigner: string().when("designer", {
		is: DesignerIsNotHereText,
		then: (schema) =>
			schema
				.required(PleaseEnterDesignerNumberText)
				.length(6, DesignerNumberMustBeSixCharactersText)
				.max(6, CharacterLimitExceeded)
				.matches(/^1\d{5}$/, MustStartWithOneAndContainOnlyDigitsText),
		otherwise: (schema) => schema.notRequired()
	}),
	customizationDetails: string().required(PleaseDescribeCustomizationText).max(500, CharacterLimitExceeded).trim(),
	customItemName: string().required(PleaseProvideItemNameText).max(25, CharacterLimitExceeded).trim(),
	manualPercentAdjustment: string().notRequired().trim(),
	manualFlatAdjustment: string().notRequired().trim(),
	modNotes: string().max(500, CharacterLimitExceeded).notRequired().trim()
});

export type QuoteRequestFields = InferType<typeof schema>;

export const defaultQuoteRequestFields: Partial<QuoteRequestFields> = {
	accountNumber: undefined,
	billToNumber: undefined,
	customizationDetails: "",
	designer: undefined,
	customDesigner: "",
	customItemName: "",
	manualPercentAdjustment: "",
	manualFlatAdjustment: "",
	modNotes: ""
} as const;
